//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wcs from '@/scripts/libs/wcs'
import { mapGetters, mapActions } from 'vuex'
import { TrustPilot } from '@/scripts/libs/trust-pilot'
import { ACTION_LOCK_TRUST_PILOT_SCRIPT } from '@/scripts/store/actions'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'

const { locale, trustPilot } = wcs.getStoreConfig()
export default {
  name: 'rb-trust-pilot',
  props: {
    target: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      businessId: trustPilot.businessId,
    }
  },
  computed: {
    ...mapGetters(['isTrustPilotScriptLoaded']),
    getLocale() {
      return WcsLocales.getSanitizedLocale(locale)
    },
  },
  mounted() {
    if (!this.isTrustPilotScriptLoaded) {
      this.loadTrustPilotScript()
    }
    this.loadTrustBoxElement()
  },
  methods: {
    ...mapActions({
      lockTrustPilotScript: ACTION_LOCK_TRUST_PILOT_SCRIPT,
    }),
    loadTrustBoxElement() {
      const trustBox = this.$refs['trustBox']
      if (trustBox) {
        window.Trustpilot?.loadFromElement(trustBox)
      }
    },
    loadTrustPilotScript() {
      this.lockTrustPilotScript()
      TrustPilot.loadScript()
    },
  },
}
